import firebase from 'firebase/app';

export enum BookingStatus {
  IN_REVIEW,
  ADMIN_APPROVED,
  OWNER_APPROVED,
  ACTIVE,
  REJECTED,
  COMPLETED,
}

export class PlaylogModel {
  adUrl: string;
  bookingId: string;
  adLength: number;
  id: string;
  lat: number;
  long: number;
  timestamp: Date;
  constructor(
    adUrl?: string,
    bookingId?: string,
    adLength?: number,
    id?: string,
    lat?: number,
    long?: number,
    timestamp?: Date
  ) {
    this.adUrl = adUrl || null;
    this.bookingId = bookingId || null;
    (this.adLength = adLength || 0), (this.id = id || null);
    this.lat = lat || null;
    this.long = long || null;
    this.timestamp = timestamp || null;
  }
}

export class Booking {
  id: string;
  userId: string;
  ownerId: string;
  fireStickId: string;
  impressions: number;
  screenInfo: ScreenInfoModel;
  interval: number;
  length: number;
  cost: number;
  adUrl: string;
  advertisementId: string;
  startDate: firebase.firestore.Timestamp;
  endDate: firebase.firestore.Timestamp;
  status: BookingStatus;
  statusMessage: string;
  playedImpressions: number;
  lastPlayTime: Date;
  nextPlayTime: Date;
  createdAt: firebase.firestore.Timestamp;
  updatedAt: firebase.firestore.Timestamp;
  isFlexibleDate: boolean;
  fileType: string;
  adPlayingIndex: number;

  constructor(
    id?: string,
    userId?: string,
    ownerId?: string,
    fireStickId?: string,
    impressions?: number,
    screenInfo?: ScreenInfoModel,
    interval?: number,
    length?: number,
    cost?: number,
    adUrl?: string,
    advertisementId?: string,
    startDate?: firebase.firestore.Timestamp,
    endDate?: firebase.firestore.Timestamp,
    status?: BookingStatus,
    statusMessage?: string,
    playedImpressions?: number,
    lastPlayTime?: Date,
    nextPlayTime?: Date,
    _createdAt?: firebase.firestore.Timestamp,
    _updatedAt?: firebase.firestore.Timestamp,
    isFlexibleDate?: boolean,
    fileType?: string,
    adPlayingIndex?: number
  ) {
    this.id = id || null;
    this.userId = userId || null;
    this.ownerId = ownerId || null;
    this.fireStickId = fireStickId || null;
    this.impressions = impressions || 0;
    this.screenInfo = screenInfo || null;
    this.interval = interval || 0;
    this.length = length || 10;
    this.cost = cost || 0;
    this.adUrl = adUrl || null;
    this.advertisementId = advertisementId;
    // Default start date would be now
    this.startDate = startDate || firebase.firestore.Timestamp.now();
    // Default end date would be a month from now
    this.endDate =
      endDate ||
      firebase.firestore.Timestamp.fromDate(
        new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000)
      );
    this.status = status || BookingStatus.IN_REVIEW;
    this.statusMessage = statusMessage || '';
    this.playedImpressions = playedImpressions || 0;
    this.lastPlayTime = lastPlayTime || null;
    this.nextPlayTime = nextPlayTime || null;
    this.createdAt = firebase.firestore.Timestamp.now();
    this.updatedAt = firebase.firestore.Timestamp.now();
    this.isFlexibleDate = isFlexibleDate || true;
    this.fileType = fileType || null;
    this.adPlayingIndex = adPlayingIndex || null;
  }
}

export class ScreenInfoModel {
  listingId: string;
  screenName: string;
  screenLocation: string;
  city: string;
  screenSize: number;
  screenRate: number;
  screenImgUrl: string;

  constructor(
    listingId?: string,
    screenName?: string,
    screenLocation?: string,
    city?: string,
    screenSize?: number,
    screenRate?: number,
    screenImgUrl?: string
  ) {
    this.listingId = listingId || null;
    this.screenName = screenName || null;
    this.screenLocation = screenLocation || null;
    this.city = city || null;
    this.screenSize = screenSize || null;
    this.screenRate = screenRate || null;
    this.screenImgUrl = screenImgUrl || null;
  }
}
